import React from 'react'
import { usePartners } from '../api'
import MultiCarousal from '../../../components/common/Multicarousal/Multicarousal'
import { useAuthStore } from '../../../store/authStore'

const OurPartners: React.FC = () => {
  const { language } = useAuthStore()
  const { data, isLoading } = usePartners()
  const partnerImages = data?.data || []

  if (isLoading) {
    return <div className="text-center py-8">Loading partners...</div>
  }

  if (!partnerImages.length) {
    return <div className="text-center py-8">No partners found.</div>
  }

  return (
    <div className="bg-[#ffff]">
      <div className="py-10 lg:px-4 w-11/12 mx-auto">
        <h2 className="text-2xl font-semibold mb-6">
          {language === 'lang_mal'
            ? 'ഞങ്ങളുടെ പങ്കാളികളും സഹയോക്താക്കളും'
            : 'Our Partners & Associates'}
        </h2>

        <MultiCarousal speed={3000} section="partners">
          {partnerImages.map((partner: any, index: number) => (
            <div
              key={`${partner.id}-${index}`}
              className="flex items-center justify-center px-4 py-2"
            >
              <img
                src={partner.file}
                alt={partner.title}
                className="w-48 h-48 object-fill mx-auto rounded"
              />
            </div>
          ))}
        </MultiCarousal>
      </div>
    </div>
  )
}

export default OurPartners
